/*
 * Cordial-IA 2026-10-12 - Barre d'annonce : rotation en fondu des messages (sections/cordial-announcement.liquid).
 * Pause au survol et au focus ; prefers-reduced-motion = aucune rotation (message 1 fixe, CSS).
 * Si un message deborde sur une ligne, l'interlettrage est resserre puis la taille reduite jusqu'a 12 px ;
 * au-dela, le texte est tronque par des points de suspension (reglage "version courte" dans l'editeur).
 * Aucun commentaire en fin de ligne.
 */
(() => {
  const bars = document.querySelectorAll('[data-cordial-announce]');
  if (!bars.length) return;
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  bars.forEach((bar) => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const msgs = [...bar.querySelectorAll('.cha-msg')];
    if (!msgs.length) return;
    msgs.forEach((m) => { if (m.querySelector('.cha-short')) m.classList.add('has-short'); });
    const fit = () => {
      msgs.forEach((m) => {
        m.style.letterSpacing = '';
        m.style.fontSize = '';
        if (m.scrollWidth <= m.clientWidth + 1) return;
        m.style.letterSpacing = '-0.02em';
        if (m.scrollWidth <= m.clientWidth + 1) return;
        const base = parseFloat(getComputedStyle(bar).fontSize) || 13;
        for (let fs = base - 0.5; fs >= 12; fs -= 0.5) {
          m.style.fontSize = fs + 'px';
          if (m.scrollWidth <= m.clientWidth + 1) return;
        }
      });
    };
    let i = 0;
    msgs[0].classList.add('is-on');
    fit();
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(bar);
    else addEventListener('resize', fit);
    if (msgs.length < 2 || RM.matches) return;
    const every = Math.max(2000, parseInt(bar.dataset.interval, 10) || 4000);
    let paused = false;
    let timer = setInterval(() => {
      if (paused || document.hidden) return;
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      setTimeout(() => msgs[i].classList.add('is-on'), 380);
    }, every);
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };
    bar.addEventListener('mouseenter', pause);
    bar.addEventListener('mouseleave', resume);
    bar.addEventListener('focusin', pause);
    bar.addEventListener('focusout', resume);
    RM.addEventListener('change', () => { if (RM.matches) { clearInterval(timer); msgs.forEach((m, k) => m.classList.toggle('is-on', k === 0)); } });
  });
})();
